import React from 'react'

export default function MisCitas() {
  return (
    <div className='page-admin container my-4'>
      <h1>Mis citas</h1>
      <table className="table">
        <thead className='table-dark'>
          <tr>
            <th scope="col">#</th>
            <th scope="col">Nombre del profesional</th>
            <th scope="col">Fecha</th>
            <th scope="col">Motivo</th>
            <th scope="col">Hora</th>
            <th scope="col">Estado</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th scope="row">1</th>
            <td>Mark</td>
            <td>Otto</td>
            <td>Otto</td>
            <td>@mdo</td>
            <td>@mdo</td>
          </tr>
          <tr>
            <th scope="row">2</th>
            <td>Jacob</td>
            <td>Thornton</td>
            <td>Thornton</td>
            <td>@fat</td>
            <td>@fat</td>
          </tr>
          <tr>
            <th scope="row">3</th>
            <td colSpan={2}>Larry the Bird</td>
            <td>@twitter</td>
            <td>@twitter</td>
            <td>@twitter</td>
          </tr>
        </tbody>
      </table>

    </div>
  )
}
